import { defaultMessageDraftState } from '@/redux/message-draft'
import { createAppSelector } from '@/redux/utils'

export const selectMessageDraft = createAppSelector(
  [
    (state) => state.messageDraft,
    (_, creatorId: number) => creatorId,
    (_, __, fanUserId: number) => fanUserId,
  ],
  (messageDraftState, creatorId, fanUserId) => messageDraftState[creatorId]?.[fanUserId] || defaultMessageDraftState,
)
